import { Card } from 'components/TeamOverview/components/Common/Card/Card';
import Box from '@mui/material/Box';
import { Grid, Typography } from '@mui/material';
import React, { useState } from 'react';
import { useAiComputeTransactionsCardStyles } from 'components/TeamOverview/components/AiComputeTransactionsCard/styles';
import { DataRow } from 'components/TeamOverview/components/AiComputeTransactionsCard/components/DataRow';
import { Search } from 'components/TeamOverview/components/AiComputeTransactionsCard/components/Search';

import { useMlModels } from 'components/TeamOverview/components/AiComputeTransactionsCard/hooks';
import { HeaderTabs } from 'components/UserProfile/components/HeaderTabs';
import {
  AI_COMPUTE_TRANSACTIONS_TABS_LIST,
  COMPLETED_TAB,
  NO_FILTER_VALUE,
} from 'components/TeamOverview/components/AiComputeTransactionsCard/constants';

import { Spinner } from 'components/Loading/Spinner/Spinner';
import { ModelFilterDropdown } from 'components/TeamOverview/components/AiComputeTransactionsCard/components/ModelFilterDropdown';
import { NoDataPlaceholder } from 'components/TeamOverview/components/AiComputeTransactionsCard/components/NoDataPlaceholder';
import { RecommendedAITools } from 'components/TeamOverview/components/RecommendedAITools/RecommendedAITools';

export const AiComputeTransactionsCard = ({ team }) => {
  const { classes } = useAiComputeTransactionsCardStyles();

  const [tabValue, setTabValue] = useState(COMPLETED_TAB);
  const [filter, setFilter] = useState('');
  const [modelFilter, setModelFilter] = useState(NO_FILTER_VALUE);
  const {
    isLoading,
    data: models,
    notFilteredByNameModels,
  } = useMlModels(team, tabValue, filter, modelFilter);

  const noData = !isLoading && !models.length;

  const handleModelFilterChange = (event) => {
    setModelFilter(event.target.value);
  };

  const handleTabChange = (event, tab) => {
    setTabValue(tab);
  };

  return (
    <>
      <Card
        header={
          <Box
            paddingY="1rem"
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            width={'100%'}
          >
            <Typography
              height="max-content"
              fontWeight={500}
              fontSize="1.125rem"
              letterSpacing="0.1em"
            >
              AI COMPUTE TRANSACTIONS
            </Typography>
            {!!models.length && (
              <ModelFilterDropdown
                classes={classes}
                models={notFilteredByNameModels}
                modelFilter={modelFilter}
                handleModelFilterChange={handleModelFilterChange}
              />
            )}
          </Box>
        }
      >
        <Box className={classes.tableHeader}>
          <HeaderTabs
            currentTabValue={tabValue}
            handleTabChange={handleTabChange}
            tabsList={AI_COMPUTE_TRANSACTIONS_TABS_LIST}
          />
          <Search classes={classes} setFilter={setFilter} />
        </Box>

        <Grid container className={classes.row}>
          <Grid item xs={1.5}>
            <Typography className={classes.columnLabel}>SOURCE</Typography>
          </Grid>
          <Grid item xs={4}>
            <Typography className={classes.columnLabel}>
              ANALYZED SLIDES
            </Typography>
          </Grid>
          <Grid item xs={2}>
            <Typography className={classes.columnLabel}>ANALYSIS</Typography>
          </Grid>
          <Grid item xs={1}>
            <Typography className={classes.columnLabel}>PAID</Typography>
          </Grid>
          <Grid item xs={2}>
            <Typography className={classes.columnLabel}>STATUS</Typography>
          </Grid>
          <Grid item xs={1.5}>
            <Typography className={classes.columnLabel}>DATE</Typography>
          </Grid>
        </Grid>

        {isLoading ? (
          <Box className={`${classes.spinnerContainer} ${classes.tableBody}`}>
            <Spinner />
          </Box>
        ) : (
          <Box className={classes.tableBody}>
            {models.length ? (
              models.map((transaction) => (
                <DataRow
                  key={transaction.uuid}
                  {...transaction}
                  classes={classes}
                />
              ))
            ) : (
              <Box
                className={`${classes.spinnerContainer} ${classes.tableBody}`}
              >
                <NoDataPlaceholder />
              </Box>
            )}
          </Box>
        )}
      </Card>
      {noData && <RecommendedAITools />}
    </>
  );
};
